interface Cancelable {
  clear: () => void;
}

/**
 * Local throttle method to minimize app bar dependencies
 */
export function throttle<T extends (...args: any[]) => void>(
  func: T,
  // Corresponds to 10 frames at 60 Hz.
  wait = 166,
) {
  let timeout: ReturnType<typeof setTimeout> | undefined;
  let latestArgs: Parameters<T> | undefined;

  function throttled(this: ThisParameterType<T>, ...args: Parameters<T>) {
    // Always call throttle with latest args
    latestArgs = args;

    if (!timeout) {
      // Leading execution
      func.apply(this, args);
      latestArgs = undefined;

      timeout = setTimeout(() => {
        clearTimeout(timeout);
        timeout = undefined;
        // Trailing execution (only if throttled was called again during throttle
        // interval)
        if (latestArgs) {
          func.apply(this, latestArgs);
          latestArgs = undefined;
        }
      }, wait);
    }
  }

  throttled.clear = () => {
    clearTimeout(timeout);
  };

  return throttled as T & Cancelable;
}
